import { NavLink, Outlet } from "react-router-dom";

import cls from "./AdminMarketplaceRouteShell.module.scss";

const linkClassName = ({ isActive }) =>
  `${cls.tabLink} ${isActive ? cls.tabLinkActive : ""}`;

export default function AdminMarketplaceRouteShell() {
  return (
    <section className={cls.page}>
      <div className={cls.bgFx} aria-hidden="true">
        <span className={cls.glowOne} />
        <span className={cls.glowTwo} />
        <span className={cls.gridGlow} />
      </div>

      <header className={cls.hero}>
        <div className={cls.heroCopy}>
          <p className={cls.kicker}>Admin Marketplace</p>
          <h1 className={cls.title}>Product Control Hub</h1>
          <p className={cls.subtitle}>
            Review, monitor, and manage marketplace submissions in one sleek
            command space.
          </p>
        </div>

        <div className={cls.heroBadgeWrap}>
          <div className={cls.heroBadge}>
            <span className={cls.heroBadgeLabel}>Mode</span>
            <strong className={cls.heroBadgeValue}>Moderation</strong>
          </div>
        </div>
      </header>

      <nav className={cls.tabs} aria-label="Marketplace sections">
        <NavLink to="pending-products" className={linkClassName}>
          <span className={cls.tabText}>Pending Products</span>
        </NavLink>
        <NavLink to="all-products" className={linkClassName}>
          <span className={cls.tabText}>All Products</span>
        </NavLink>
      </nav>

      <div className={cls.contentShell}>
        <Outlet />
      </div>
    </section>
  );
}
